<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-toolbar color="secondary" dark>
        <v-toolbar-title>{{ $t("addPlayListLink") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-5">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
              v-model="playlistLink"
              :label="$t('videoLibrary.playlistLink')"
              :rules="[rules.required, rules.youtubePlaylist]"
              outlined
              dense
              prepend-inner-icon="mdi-youtube"
              hint="مثال: https://www.youtube.com/playlist?list=PLxxxxxxxx"
              persistent-hint
              :loading="loading"
          ></v-text-field>

          <v-alert
              v-if="errorMessage"
              type="error"
              dismissible
              @input="errorMessage = ''"
              class="mt-3"
          >
            {{ errorMessage }}
          </v-alert>

          <v-alert
              v-if="successMessage"
              type="success"
              dismissible
              @input="successMessage = ''"
              class="mt-3"
          >
            {{ successMessage }}
          </v-alert>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="close" :disabled="loading">
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
            color="primary"
            @click="submit"
            :disabled="!valid"
            :loading="loading"
        >
          {{ $t("add") }}
          <v-icon right>mdi-check</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PlaylistDialog",
  props: {
    openDialog: {
      type: Boolean,
      required: true
    },
    category: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      playlistLink: "",
      errorMessage: "",
      successMessage: "",
      rules: {
        required: (value) => !!value || this.$t("ThisFieldIsRequired"),
        youtubePlaylist: (value) => {
          if (!value) return true;

          // YouTube playlist URL patterns
          const patterns = [
            /^https?:\/\/(www\.)?youtube\.com\/playlist\?list=[\w-]+/,
            /^https?:\/\/(www\.)?youtube\.com\/watch\?v=[\w-]+&list=[\w-]+/,
            /^https?:\/\/youtu\.be\/[\w-]+\?list=[\w-]+/
          ];

          const isValid = patterns.some(pattern => pattern.test(value));
          return isValid || this.$t("videoLibrary.invalidPlaylistLink");
        }
      }
    };
  },
  watch: {
    openDialog(val) {
      this.dialog = val;
      if (!val) {
        this.reset();
      }
    },
    dialog(val) {
      if (!val) {
        this.$emit("close");
      }
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.errorMessage = "";
        this.successMessage = "";

        try {
          const form = new FormData();
          form.append("playlist_link", this.playlistLink);
          form.append("category_id", this.category.id);

          const response = await this.$axios.post(
              "video_library/videos/import/playlist",
              form
          );

          if (response.data.status === "Successful") {
            this.successMessage =
                response.data.message ||
                this.$t("videoLibrary.playlistImportSuccess");

            setTimeout(() => {
              this.$emit("refresh");
              this.close();
            }, 1500);
          }
        } catch (error) {
          if (error.response?.data?.message) {
            this.errorMessage = error.response.data.message;
          } else {
            this.errorMessage = this.$t("videoLibrary.playlistImportError");
          }
        } finally {
          this.loading = false;
        }
      }
    },

    close() {
      this.dialog = false;
      this.$emit("close");
    },

    reset() {
      this.playlistLink = "";
      this.errorMessage = "";
      this.successMessage = "";
      if (this.$refs.form) {
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
      }
    }
  }
};
</script>
